import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import Select from 'react-select';


export const renderBootstrapField = ({
  input,
  label,
  placeholder,
  type,
  meta: { touched, error, warning },
}) => (
    <InputGroup>
      {label && <ControlLabel>{label}</ControlLabel>}
      <FormControl {...input} type={type} placeholder={placeholder} />
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
    </InputGroup>
  );


const renderSelectInput = ({ input, options, name, id, label, help, meta: { active, touched, error, warning } }) => {

  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <FormControl componentClass="select"
        onChange={(value) => input.onChange(value)}
        name={name}
        value={input.value}
      >
        <option value={0}>Select</option>
        {options.map((option) => <option key={option.id} value={option.id}>{option.username}</option>)}
      </FormControl>
    </FormGroup>
  )
}


const TourEditForm = ({ onSubmit, onCancel, initialValues, isNew, tourManagers }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={values => {
      const errors = {};
      if (!values.name) {
        errors.FORM_ERROR = 'Please enter a name';
        return errors;
      }

      if(values.manager == 0) {
        errors.FORM_ERROR = 'Please select manager';
        return errors;
      }
      return errors
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => {
      const buttonLabel = isNew ? 'Add' : 'Save';
      const buttonIcon = isNew ? 'fa fa-plus fa-lg' : 'fa fa-pencil fa-lg';
      return (
        <form onSubmit={handleSubmit}>
          {isNew && (
            <p>Provide the name and short description of the traveling group you are planning.</p>
          )}

          <FormGroup>
            <Field
              name="name"
              type="text"
              component={renderBootstrapField}
              label="Name"
              placeholder="Name of the group traveling"
            />
          </FormGroup>
          <FormGroup>
            <Field
              name="tag_line"
              type="text"
              component={renderBootstrapField}
              label="Description"
              placeholder="Short description of the travel"
            />
          </FormGroup>
          <FormGroup>
            <Field
              name="manager"
              component={renderSelectInput}
              label="Travel Manager"
              options={tourManagers}
            />
          </FormGroup>
          {!pristine &&
            errors.FORM_ERROR && <p className="alert alert-danger">{errors.FORM_ERROR}</p>}
          <FormGroup>
            <ButtonToolbar>
              <Button
                disabled={Object.keys(errors).length !== 0 || submitting}
                bsStyle="success"
                type="submit"
              >
                <i className={buttonIcon} /> {buttonLabel}
              </Button>
              <Button
                bsStyle="success"
                onClick={onCancel}
              >
                <i className="fa fa-trash fa-lg" /> Cancel
              </Button>
            </ButtonToolbar>
          </FormGroup>
        </form>
      );
    }}
  />
);

export default TourEditForm;



// WEBPACK FOOTER //
// src/routes/tours/components/TourEditForm.js